import { makeStyles } from '@material-ui/core';
import { FORM_COLORS } from './constants';

/**
 * Estilos compartidos por las pestañas del formulario de publicación.
 * Reproducen el look del mockup (campos con borde, foco rosa, hints, etc.).
 */
export const useFormStyles = makeStyles(() => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '0 22px',
  },
  field: {
    marginBottom: 15,
  },
  fieldFull: {
    gridColumn: '1 / -1',
  },
  label: {
    display: 'block',
    fontSize: 13,
    color: FORM_COLORS.textSecondary,
    marginBottom: 5,
    fontWeight: 500,
  },
  required: {
    color: FORM_COLORS.pink,
    marginLeft: 3,
  },
  input: {
    width: '100%',
    padding: '7px 10px',
    border: `0.5px solid ${FORM_COLORS.border}`,
    borderRadius: 8,
    fontSize: 13,
    fontFamily: 'inherit',
    color: FORM_COLORS.text,
    background: FORM_COLORS.white,
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color .15s',
    '&:focus': {
      borderColor: FORM_COLORS.pink,
    },
    '&:disabled': {
      background: FORM_COLORS.bg,
      color: FORM_COLORS.textSecondary,
      cursor: 'not-allowed',
      opacity: 0.7,
    },
  },
  hint: {
    fontSize: 11,
    color: FORM_COLORS.textSecondary,
    margin: '4px 0 0',
    lineHeight: 1.4,
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: 500,
    color: FORM_COLORS.textSecondary,
    marginBottom: 10,
  },
}));
